import { useTranslation } from "react-i18next";
import { normLang } from "@/i18n";
import api from "@/lib/api";

const LANGS = [["fr", "FR"], ["en", "EN"]];

export function LanguageSwitcher({ className = "", variant = "" }) {
  const { i18n } = useTranslation();
  const cur = normLang(i18n.language);

  const pick = (code) => {
    if (code === cur) return;
    i18n.changeLanguage(code);
    // Best-effort: persist the choice on the account so emails match the user's language.
    // Silently ignored when the visitor is not authenticated (interceptor → 401).
    if (localStorage.getItem("twp_token")) {
      api.put("/me/language", { lang: code }).catch(() => {});
    }
  };

  return (
    <div data-testid={`language-switcher${variant}`} className={`inline-flex items-center rounded-full border border-border p-0.5 ${className}`}>
      {LANGS.map(([code, label]) => (
        <button
          key={code}
          data-testid={`lang-${code}${variant}`}
          onClick={() => pick(code)}
          aria-pressed={cur === code}
          className={`rounded-full px-2.5 py-1 text-xs font-semibold transition-colors ${cur === code ? "bg-primary text-primary-foreground" : "text-muted-foreground hover:text-foreground"}`}
        >
          {label}
        </button>
      ))}
    </div>
  );
}
